// extracted by mini-css-extract-plugin
module.exports = {"description":"StoreListItem_description__P3CSg"};